/* global axios */
import ApiClient from '../ApiClient';

class CaptainTrainingDocument extends ApiClient {
  constructor() {
    super('captain/training_documents', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(this.url, {
      params: { assistant_id: assistantId },
    });
  }
}

export default new CaptainTrainingDocument();
